<!-- @format -->

<ng-container *transloco="let t">
  <fudis-form [title]="t('PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.PAYER_DETAILS')" [level]="2">
    <fudis-form-content>
      <fudis-grid [columns]="{ sm: 2, lg: 'inputLg inputLg' }" [rowGap]="'none'">
        <fudis-text-input [label]="t('FIELD_NAMES.firstName')" [control]="form.controls.firstName" />
        <fudis-text-input [label]="t('FIELD_NAMES.lastName')" [control]="form.controls.lastName" />
        <fudis-text-input [label]="t('FIELD_NAMES.emailAddress')" [control]="form.controls.email" />
      </fudis-grid>

      <fudis-grid [classes]="'fudis-mt-sm'">
        <fudis-grid-item>
          <fudis-checkbox
            [label]="t('PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.I_ACCEPT_TERMS')"
            [control]="form.controls.terms.controls.acceptTerms" />

          @let termsAndInstructions = t("PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.TERMS_AND_INSTRUCTIONS");
          @if (paymentInstructionsUrl$ | async | localizedString; as instructionsUrl) {
            <a fudisLink [title]="termsAndInstructions" [external]="true" [href]="instructionsUrl"></a>
          } @else {
            <fudis-body-text>{{ termsAndInstructions }}</fudis-body-text>
          }
        </fudis-grid-item>

        <fudis-notification [variant]="'info'">
          {{ t("PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PAYMENT.EXTERNAL_PAYMENT_NOTIFICATION") }}
        </fudis-notification>

        <fudis-grid-item>
          <fudis-button
            [label]="t('BUTTON.RETURN')"
            [icon]="'back'"
            [variant]="'secondary'"
            class="fudis-mr-sm"
            (handleClick)="previous.emit()" />
          <fudis-button
            [label]="t('STUDENT_APPLICATIONS.PAY_AND_SEND')"
            fudisFormSubmit
            [formValid]="form.valid"
            (handleClick)="onSubmit()" />
        </fudis-grid-item>
      </fudis-grid>
    </fudis-form-content>
  </fudis-form>
</ng-container>
